import { isTouchEnabled } from "./touch-util";
import { getInputSelection, setCaretPosition } from "./caret-util";

export { isTouchEnabled, getInputSelection, setCaretPosition };
